module.exports = __webpack_public_path__ + "static/media/download.0fa13bc0.jpeg";